/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MappingCellReferenceRow } from './MappingCellReferenceRow';
import type { ReferenceCreatedBy } from './ReferenceCreatedBy';
export type SecurityMappingRow = {
  id: number;
  source_type: string;
  document_reference: number;
  field_name: string | null;
  sheet_name: string;
  cell_references: Array<MappingCellReferenceRow>;
  /**
   * Null for callers who do not review AI work.
   */
  status: SecurityMappingRow.status | null;
  /**
   * Null for callers who do not review AI work.
   */
  review_reason: string | null;
  /**
   * Null for callers who do not review AI work.
   */
  created_source: SecurityMappingRow.created_source | null;
  created_by: ReferenceCreatedBy;
  created_at: string;
  updated_at: string;
};
export namespace SecurityMappingRow {
  /**
   * Null for callers who do not review AI work.
   */
  export enum status {
    PENDING = 'pending',
    ACCEPTED = 'accepted',
    DISMISSED = 'dismissed',
  }
  /**
   * Null for callers who do not review AI work.
   */
  export enum created_source {
    AI = 'ai',
    HUMAN = 'human',
  }
}

